// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"2663ba91","938":"dc1444e3"}[chunkId] + ".chunk.js";
};